<template>
  <span class="product-cta">
    <button
      v-if="!contains(productId)"
      class="btn btn-primary my-sm-3 mr-md-2 mt-2 mb-2"
      @click="trigger()"
      ::class="classes"
    >Add To Basket</button>
    <div class="product-cta-qtas" v-else>
      <button class="cta-button" @click="decrease()" ::class="classes">-</button>
      <input class="item-qty" disabled :value="qty">
      <button class="cta-button" @click="increase()" ::class="classes">+</button>
    </div>
    <button
      v-if="showDetailsButton"
      class="btn btn-primary btn-secondary my-sm-3 mr-md-2 mt-2 mb-2"
      @click="showProductDetails"
      ::class="classes"
    >Details</button>
  </span>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "product-cta-button",
  props: {
    added: Boolean,
    showDetailsButton: Boolean,
    productId: String
  },
  methods: {
    trigger: function() {
      const id = this.$props.productId;
      if(!this.contains(id)) {
        this.$emit('addToBasket');
      } else {
        this.$emit('removeFromBasket', this.lineItem(id));
      }
    },
    decrease: function() {
      const id = this.$props.productId;
      this.$emit('descreaseBasketItem', this.lineItem(id));
    },
    increase: function() {
      const id = this.$props.productId;
      this.$emit('increaseBasketItem', this.lineItem(id));
    },
    showProductDetails: function() {
      this.$emit('showProductDetails');
    }
  },
  computed: {
    ...mapGetters("shopify", ["contains", "lineItem"]),
    classes: function() {
      return [
        'cta-button'
      ]
    },
    qty: function() {
      return this.lineItem(this.$props.productId).quantity;
    }
  }
};
</script>